// React
import React from "react";

// Styles
import './panels.css';
import '../../assets/css/animations.css';

const HiddenMenu = (props) => (

 <div className={ props.show ? 'hidden-menu ' : 'hidden-menu hide' }>{props.children}</div>
);

export default HiddenMenu;


// WEBPACK FOOTER //
// ./src/Components/Panels/HiddenMenu.js